export const SIGN_TRANSLATIONS = {
  Aries: 'Aries',
  Taurus: 'Tauro',
  Gemini: 'Géminis',
  Cancer: 'Cáncer',
  Leo: 'Leo',
  Virgo: 'Virgo',
  Libra: 'Libra',
  Scorpio: 'Escorpio',
  Sagittarius: 'Sagitario',
  Capricorn: 'Capricornio',
  Aquarius: 'Acuario',
  Pisces: 'Piscis',
};

export function translateSign(sign) {
  const raw = String(sign || '').trim();
  if (!raw) return '';

  const normalized =
    raw.charAt(0).toUpperCase() + raw.slice(1).toLowerCase();

  return SIGN_TRANSLATIONS[normalized] || raw;
}